import { render, staticRenderFns } from "./FormSendTarget.vue?vue&type=template&id=f6f16e94&scoped=true&lang=pug"
import script from "./FormSendTarget.vue?vue&type=script&lang=ts"
export * from "./FormSendTarget.vue?vue&type=script&lang=ts"
import style0 from "./FormSendTarget.vue?vue&type=style&index=0&id=f6f16e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f16e94",
  null
  
)

export default component.exports